import globalStore from '$$globalStore';
import app from '$$app';

function onTaskCommentUpdated(event) {
  event.data.updated.forEach(editedComment => {
    const storeComment = globalStore.getters['comments/getCommentById'](editedComment.commentId);

    if (!storeComment) {
      return;
    }

    const resource = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);
    const payload = {
      projectId: storeComment.projectId,
      commentId: storeComment.id,
      payload: editedComment.updatedFields,
    };

    globalStore.commit('comments/updateComment', { ...payload, fromGantt: false }, { root: true });

    if (resource.resourceProjects.find(item => item.projectId === storeComment.projectId)) {
      globalStore.commit('comments/removeCommentAction', { commentId: storeComment.id, fromGantt: false }, { root: true });

      const commentAction = {
        commentId: storeComment.id,
        date: storeComment.createdAt,
        read: 0,
        userId: window.user.id,
      };

      globalStore.commit('comments/addCommentAction', { ...commentAction, fromGantt: false }, { root: true });
    }
  });

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.comments && event.data.comments.length ? event.data.comments.map(i => i.taskId) : [],
  });
}

export default onTaskCommentUpdated;
